"use client";

import React from "react";
export default function Testimonials() {
  return null;
}